import React, { useState } from 'react';
import HistorialService from '../services/historiales';
import { notificationSystem } from '../utils/notifications';

function Diagnosticos({ diagnosticos, paciente_id, onRefresh }) {
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fecha_diagnostico: new Date().toISOString().split('T')[0],
    diagnostico_principal: '',
    diagnosticos_secundarios: '',
    codigo_cie10: '',
    criterios_diagnosticos: '',
    comorbilidades: '',
    observaciones: '',
    profesional_responsable: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({...prev, [name]: value}));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await HistorialService.agregarDiagnostico(paciente_id, formData);
      notificationSystem.success('Diagnóstico registrado');
      setMostrarFormulario(false);
      setFormData({
        fecha_diagnostico: new Date().toISOString().split('T')[0],
        diagnostico_principal: '',
        diagnosticos_secundarios: '',
        codigo_cie10: '',
        criterios_diagnosticos: '',
        comorbilidades: '',
        observaciones: '',
        profesional_responsable: ''
      });
      onRefresh();
    } catch (error) {
      console.error('Error:', error);
      notificationSystem.error('Error al guardar diagnóstico');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="diagnosticos-section">
      <button 
        className="btn-agregar" 
        onClick={() => setMostrarFormulario(!mostrarFormulario)}
      >
        + Agregar Diagnóstico
      </button>

      {mostrarFormulario && (
        <form onSubmit={handleSubmit} className="formulario">
          <div className="form-row">
            <div>
              <label>Fecha del Diagnóstico *</label>
              <input 
                type="date" 
                name="fecha_diagnostico"
                value={formData.fecha_diagnostico}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label>Código CIE-10</label>
              <input 
                type="text" 
                name="codigo_cie10"
                placeholder="ej: F32.1"
                value={formData.codigo_cie10}
                onChange={handleChange}
              />
            </div>
          </div>

          <div>
            <label>Diagnóstico Principal *</label>
            <input 
              type="text" 
              name="diagnostico_principal"
              placeholder="Diagnóstico principal"
              value={formData.diagnostico_principal}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label>Diagnósticos Secundarios</label>
            <textarea 
              name="diagnosticos_secundarios"
              placeholder="Listado de diagnósticos secundarios"
              value={formData.diagnosticos_secundarios}
              onChange={handleChange}
              rows="2"
            />
          </div>

          <div>
            <label>Criterios Diagnósticos</label>
            <textarea 
              name="criterios_diagnosticos"
              placeholder="Criterios utilizados para el diagnóstico"
              value={formData.criterios_diagnosticos}
              onChange={handleChange}
              rows="3"
            />
          </div>

          <div>
            <label>Comorbilidades</label>
            <textarea 
              name="comorbilidades"
              placeholder="Condiciones coexistentes"
              value={formData.comorbilidades}
              onChange={handleChange}
              rows="2"
            />
          </div>

          <div>
            <label>Profesional Responsable</label>
            <input 
              type="text" 
              name="profesional_responsable"
              placeholder="Nombre del profesional"
              value={formData.profesional_responsable}
              onChange={handleChange}
            />
          </div>

          <div>
            <label>Observaciones</label>
            <textarea 
              name="observaciones"
              placeholder="Observaciones adicionales"
              value={formData.observaciones}
              onChange={handleChange}
              rows="3"
            />
          </div>

          <div className="form-buttons">
            <button type="submit" className="btn-guardar" disabled={loading}>
              {loading ? 'Guardando...' : 'Guardar Diagnóstico'}
            </button>
            <button 
              type="button" 
              className="btn-cancelar" 
              onClick={() => setMostrarFormulario(false)}
              disabled={loading}
            >
              Cancelar
            </button>
          </div>
        </form>
      )}

      <div className="diagnosticos-lista">
        {diagnosticos.length === 0 ? (
          <p className="no-data">No hay diagnósticos registrados</p>
        ) : (
          diagnosticos.map((diag) => (
            <div key={diag.id} className="diagnostico-card">
              <div className="nota-header">
                <div>
                  <h4>{diag.diagnostico_principal}</h4>
                  <small>{new Date(diag.fecha_diagnostico).toLocaleDateString()}</small>
                </div>
                {diag.codigo_cie10 && <span className="codigo-cie10">{diag.codigo_cie10}</span>}
              </div>

              {diag.diagnosticos_secundarios && (
                <div className="info-section">
                  <strong>Diagnósticos Secundarios:</strong>
                  <p>{diag.diagnosticos_secundarios}</p>
                </div>
              )}

              {diag.criterios_diagnosticos && (
                <div className="info-section">
                  <strong>Criterios Diagnósticos:</strong>
                  <p>{diag.criterios_diagnosticos}</p>
                </div>
              )}

              {diag.comorbilidades && (
                <div className="info-section">
                  <strong>Comorbilidades:</strong>
                  <p>{diag.comorbilidades}</p>
                </div>
              )}

              {diag.profesional_responsable && (
                <p><strong>Profesional:</strong> {diag.profesional_responsable}</p>
              )}

              {diag.observaciones && (
                <div className="info-section">
                  <strong>Observaciones:</strong>
                  <p>{diag.observaciones}</p>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Diagnosticos;
